import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditSkill from "../../components/skills/FormAddEditSkill";

const CreateSkill = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/skills");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditSkill
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateSkill;